import React from 'react'

import WebhookPixAutomaticoFormPageContainer from './WebhookPixAutomaticoFormPageContainer'

export class WebhookPixAutomaticoFormPage extends React.Component {
  render() {
    return <WebhookPixAutomaticoFormPageContainer {...this.props} />
  }
}
